import { ColumnDef } from '@tanstack/react-table';

import { ContainerListViewModel } from '@/react/docker/containers/types';
import { trimSHA } from '@/docker/filters/utils';

export const image: ColumnDef<ContainerListViewModel> = {
  header: 'Image',
  accessorFn: (row) => trimSHA(row.Image),
  id: 'image',
  enableHiding: true,
};
